module OfficeExt {
  export interface ExtendedManifestCacheEntry {
    addinId: string;
    extendedManifest: ExtendedManifest;
  }
}
